export var LoanSummaryStatus;
(function (LoanSummaryStatus) {
    LoanSummaryStatus["ACTIVE"] = "ACTIVE";
    LoanSummaryStatus["CLOSED_LOST"] = "CLOSED LOST";
    LoanSummaryStatus["HIDDEN"] = "HIDDEN";
    LoanSummaryStatus["PAID"] = "PAID";
    LoanSummaryStatus["PAST_DUE"] = "PAST DUE";
})(LoanSummaryStatus || (LoanSummaryStatus = {}));
//# sourceMappingURL=loan-summary-status.js.map